module.exports = __webpack_public_path__ + "img/icon-delete.9a41c47b.svg";